<template>
  <div class="content-wrapper-block">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
/**
 * Component for wrapping system messages and short pieces of text.
 *
 * Adds padding and border around the wrapped element.
 */
</script>

<style lang="scss" scoped>
.content-wrapper-block {
  padding: 40px;
  border-radius: 14px;
  border: 1px solid $c-border-2;
}

.night-mode .content-wrapper-block {
  border-color: $c-black-8;
}
</style>
